<div class="container-fluid spacer-top-navigation">
  <div class="container">
    @switch (facade.customerClassification$ | async) {
      @case ('BASIC') {
        <ng-container *ngTemplateOutlet="basic" />
      }
      @case ('ADVANCED') {
        <shared-most-active-assets [instrumentType]="instrumentType" />
        <stocks-discover-news />
        <shared-winner-loser [instrumentType]="instrumentType" />
        <stocks-famous />
        <statistics-trade-ticker-by-instrument-type [instrumentType]="instrumentType" />
      }
      @default {
        <ng-container *ngTemplateOutlet="basic" />
      }
    }
  </div>
</div>

<ng-template #basic>
  @if (!isDismissedNotification) {
    <div class="tile">
      <div class="zero-text p-bigger-med mb-3">{{ 'asset-class-overview.stocks-overview.headline' | transloco }}</div>
      <web-design-system-notification
        color="blue"
        [cacheIdentifier]="notificationCacheKey"
        [headline]="'asset-class-overview.stocks-overview.notification.headline' | transloco"
        [isDismissible]="true"
        (dismissClicked)="isDismissedNotification = true"
      >
        <span [innerHTML]="'asset-class-overview.stocks-overview.notification.text' | transloco"></span>
      </web-design-system-notification>
    </div>
  }
  <stocks-famous />
  <shared-most-active-assets [instrumentType]="instrumentType" />
  <stocks-discover-news />
  <shared-winner-loser [instrumentType]="instrumentType" />
  <statistics-trade-ticker-by-instrument-type [instrumentType]="instrumentType" />
</ng-template>
